import { GuidService } from 'ui-components/services/guid-service';
import { BulkActions } from '../../../enums/bulk-actions';
import * as BulkUpdateActions from '../../../store/bulk/update/bulk.update.actions';

export const ShippingAccount = {
  id: 'shipping-account',
  name: BulkActions.shippingAccount.message,

  makeHandler: (dispatch, bulkUpdateTypeData) => {
    return (ids, filters) =>
      dispatch(
        BulkUpdateActions.startBulkUpdateJob(bulkUpdateTypeData, [BulkActions.shippingAccount], ids, GuidService.newGuid(), filters),
      );
  },
};
